module.exports = __webpack_public_path__ + "img/camera.f828764d.png";